import React, { useContext } from 'react';
import {
  getOrderedOptions,
  RuleActionParameterNames,
  RulesContext,
} from '../../../../../../services/common/RulesUtils';
import i18next from 'i18next';
import { Grid } from '@mui/material';
import RuleSelectInput from '../../../../../../components/rules/RuleSelectInput';

const ContextAddAndArchiveThirdParty = ({ fieldName }) => {
  const { contextModels } = useContext(RulesContext);
  const parsedModels = getOrderedOptions(contextModels.map((model) => {
    return {
      label: model.name,
      value: JSON.stringify(model.id),
    };
  }));

  return (
    <Grid
      container
      spacing={2}
      style={{ alignItems: 'center', }}
    >
      <Grid item xs={12} md={8}>
        <RuleSelectInput
          fieldName={`${fieldName}.${RuleActionParameterNames.CONTEXT_MODEL_ID}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.contextTypeCode.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.contextTypeCode.placeholder`)}
          options={parsedModels}
          onChange={() => { }}
          isRequired
          validate={()=>{}}
          labelVariant='chip'
        />
      </Grid>
    </Grid>
  );
};

export default ContextAddAndArchiveThirdParty;
